import { Component,  OnInit } from '@angular/core';
import { CommonService } from '@common/services/common.service';
@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
})
export class AppLoaderComponent implements OnInit {

    public loaderStatus:boolean = false;
      
    constructor(){
        this.subscribeLoaderStatusChange();
    }

    private subscribeLoaderStatusChange(){
        CommonService.loaderStatus.subscribe(data => {
            setTimeout(() => {
              this.loaderStatus = data;
            });
        });
    }

    ngOnInit(){

    }
  }